/* eslint-disable */
import 'whatwg-fetch'

// All changes to the store and API calls is made by dispatching a Action
// Mutations to the store need to commit a mutation

import { i18n } from '../../main'
import moment from 'moment'
import { resolve } from 'core-js/fn/promise'

//Live url
const url = 'https://r360-api.klappen.se:8080'

// isLocal == true - will use local data
let isLocal = process.env.VUE_APP_IS_LOCAL == 'yes'
if (isLocal) {
	window.console.warn(
		'Data is loaded from local JSON. Set VUE_APP_IS_LOCAL to "no" in the .env.local file to prevent this'
	)
}

//Test Url
//const testUrl = ' http://localhost:3000';

export default {
	/*GET_WEATHER({ commit }) {
    fetch(url + '/weather').then((resp) => resp.json()).then(function (data) {
      commit('SET_WEATHER', data)
    }).catch(function (error) {
      window.console.warn('Fail to get weather data from API');
      window.console.warn(error);
    });
	},*/

	GET_CONFROMATION_ID({ commit }, payload) {
		commit('SET_CONFROMATION_ID', payload)
	},

	CHANGE_API_RESP_STATUS({ commit }, payload) {
		commit('SET_API_RESP_STATUS', payload)
	},

	PUT_ACCOMMODATION_IN_CART({ commit, dispatch }, payload) {
		commit('PUT_ACCOMMODATION_IN_CART', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	CHANGE_ACCOMMODATION_IN_CART({ commit }, payload) {
		commit('CHANGE_ACCOMMODATION_IN_CART', payload)
	},

	REMOVE_ACCOMMODATION_FROM_CART({ commit, dispatch }, payload) {
		// payload == accommodation
		dispatch('GTM_PUSH_ACCOMMODATION_REMOVE_FROM_CART', payload)
		commit('DELETE_ACCOMMODATION_FROM_CART', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	//Cart action for skipass
	ADD_CART_SKIPASS({ commit, dispatch }, payload) {
		dispatch('GTM_PUSH_SKIPASS_ADD_TO_CART', payload)
		commit('SET_CART_SKIPASS', payload)
	},

	REMOVE_CART_SKIPASS({ commit, state, dispatch }, payload) {
		state.cart.skipass.forEach(each => {
			if (each.uniqueId == payload.uniqueId) {
				dispatch('GTM_PUSH_SKIPASS_REMOVE_FROM_CART', each)
			}
		})

		commit('DELETE_CART_SKIPASS', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	CHANGE_CART_PRODUCT({ commit }, payload) {
		// Payload = {type: 'type of cart', product: product}
		commit('CHANGE_CART_PRODUCT', payload)
	},

	CHANGE_CART_SKIPASS_GUEST({ commit }, payload) {
		commit('PUT_CART_SKIPASS_GUEST', payload)
	},

	GET_CART_SKIPASS_KEYCARD({ commit }, payload) {
		commit('SET_CART_SKIPASS_KEYCARD', payload)
	},

	//Cart action for skirental
	ADD_CART_SKIRENTAL({ commit, dispatch }, payload) {
		dispatch('GTM_PUSH_SKIRENTAL_ADD_TO_CART', payload)
		commit('SET_CART_SKIRENTAL', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	REMOVE_CART_SKIRENTAL({ commit, state, dispatch }, payload) {
		state.cart.skirental.forEach(each => {
			if (each.uniqueId == payload.uniqueId) {
				dispatch('GTM_PUSH_SKIRENTAL_REMOVE_FROM_CART', each)
			}
		})
		commit('DELETE_CART_SKIRENTAL', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	CHANGE_CART_SKIRENTAL_GUEST({ commit }, payload) {
		commit('PUT_CART_SKIRENTAL_GUEST', payload)
	},

	//Cart action for skischool
	ADD_CART_SKISCHOOL({ commit, dispatch }, payload) {
		dispatch('GTM_PUSH_SKISCHOOL_ADD_TO_CART', payload)
		commit('SET_CART_SKISCHOOL', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	REMOVE_CART_SKISCHOOL({ commit, state, dispatch }, payload) {
		state.cart.skischool.forEach(each => {
			if (each.uniqueId == payload.uniqueId) {
				dispatch('GTM_PUSH_SKISCHOOL_REMOVE_FROM_CART', each)
			}
		})
		commit('DELETE_CART_SKISCHOOL', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	CHANGE_CART_SKISCHOOL_GUEST({ commit }, payload) {
		commit('PUT_CART_SKISCHOOL_GUEST', payload)
	},

	//Cart action for activities
	ADD_CART_ACTIVITIES({ commit, dispatch }, payload) {
		//dispatch('GTM_PUSH_ACTIVITIES_ADD_TO_CART', payload)
		commit('SET_CART_ACTIVITIES', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	REMOVE_CART_ACTIVITIES({ commit, state, dispatch }, payload) {
		state.cart.activities.forEach(each => {
			if (each.uniqueId == payload.uniqueId) {
				//dispatch('GTM_PUSH_ACTIVITIES_REMOVE_FROM_CART', each)
			}
		})
		commit('DELETE_CART_ACTIVITIES', payload)

		//Set checkout type (fast/normal)
		dispatch('SET_CHECKOUT_TYPE')
	},

	CHANGE_CART_ACTIVITIES_GUEST({ commit }, payload) {
		commit('PUT_CART_ACTIVITIES_GUEST', payload)
	},

	//Tar bort ett specifikt boende från varukorgen
	// DELETE_CART_ITEM({ commit }, payload) {
	// 	console.log('payload: ', payload);
	// 	commit('DELETE_CART_ITEM', payload)
	// },

	//Tömmer varukorgen när en beställning är lagd
	EMPTY_CART({ commit }, payload) {
		commit('EMPTY_CART', payload)
	},

	SET_CART_ADDONS({ commit }, payload) {
		commit('SET_CART_ADDONS', payload)
	},

	GET_CART_SKIRENTAL_INSURANCE({ commit }, payload) {
		commit('SET_CART_SKIRENTAL_INSURANCE', payload)
	},

	GET_CART_SKIRENTAL_COMMENT({ commit }, payload) {
		commit('SET_CART_SKIRENTAL_COMMENT', payload)
	},

	GET_CART_SKISCHOOL_COMMENT({ commit }, payload) {
		commit('SET_CART_SKISCHOOL_COMMENT', payload)
	},

	GET_CART_ACTIVITIES_COMMENT({ commit }, payload) {
		commit('SET_CART_ACTIVITIES_COMMENT', payload)
	},

	UPDATE_CART_DELIVERY({ commit }, payload) {
		commit('UPDATE_CART_DELIVERY', payload)
	},

	//Sätter användaren till null
	RESET_USER({ commit }) {
		commit('SET_USER', null)
	},

	GET_SEARCHFILTERS({ commit }, payload) {
		commit('SET_SEARCHFILTERS', payload)
	},

	GET_DATES_AND_PEOPLE({ commit }, payload) {
		commit('SET_DATES_AND_PEOPLE', payload)
	},

	SET_ACCOMMODATIONS_LIST({ commit, dispatch }, payload) {
		commit('SET_ACCOMMODATIONS_LIST', payload)
	},

	SET_ACCOMMODATION_RANDOM_LIST_ORDER({ commit, dispatch }, payload) {
		commit('SET_ACCOMMODATION_RANDOM_LIST_ORDER', payload)
	},

	//Lägger en hel bokning i varukorgen
	ADD_BOOKING_TO_CART({ commit }, payload) {
		commit('EMPTY_CART')
		commit('ADD_BOOKING_TO_CART', payload)
	},

	/*GET_CABIN_AREAS({ commit }, payload) {
    return new Promise((resolve) => {
      fetch(testUrl + '/cabinAreas').then((resp) => resp.json()).then(function (data) {
        commit('SET_CABIN_AREAS', data)
        resolve(data)
      }).catch(function (error) {
        window.console.warn('Failed to get cabin areas');
        window.console.warn(error);
      });
    });
  },*/

	PRODUCT_SELECTED_FILTERS({ commit }, payload) {
		commit('SET_PRODUCT_SELECTED_FILTERS', payload)
	},
	PRODUCT_SELECTED_FILTER_TYPE({ commit }, payload) {
		commit('SET_PRODUCT_SELECTED_FILTER_TYPE', payload)
	},
	PRODUCT_SELECTED_ITEMS({ commit, dispatch }, payload) {
		if (payload.type == 'skipass') {
			dispatch('GTM_PUSH_SKIPASS_CLICK', payload)
		}
		if (payload.type == 'skirental') {
			dispatch('GTM_PUSH_SKIRENTAL_CLICK', payload)
		}
		if (payload.type == 'skischool') {
			dispatch('GTM_PUSH_SKISCHOOL_CLICK', payload)
		}
		commit('SET_PRODUCT_SELECTED_ITEMS', payload)
	},
	REMOVE_PRODUCT_SELECTED_ITEM({ commit }, payload) {
		commit('REMOVE_PRODUCT_SELECTED_ITEM', payload)
	},
	REMOVE_ALL_PRODUCT_SELECTED_ITEMS({ commit }, payload) {
		commit('REMOVE_ALL_PRODUCT_SELECTED_ITEMS', payload)
	},
	CLEAR_PRODUCT_FILTERS_AND_ITEMS({ commit }) {
		commit('CLEAR_PRODUCT_FILTERS_AND_ITEMS')
	},

	TOGGLE_GLOBAL_MODAL({ commit }, payload) {
		commit('TOGGLE_GLOBAL_MODAL', payload)
	},

	TOGGLE_CART_ACCORDION({ commit }, payload) {
		// Payload = {showSkipass: true}
		commit('TOGGLE_CART_ACCORDION', payload)
	},

	VALIDATE_PRODUCTS_IN_CART({ commit, state, dispatch }) {
		return new Promise(resolve => {
			let everytingIsValid = true
			const cartProductList = [
				...state.cart.skipass,
				...state.cart.skirental,
				...state.cart.skischool,
				...state.cart.activities
			]

			//Fast checkout
			if (state.cart.fastCheckout) {
				resolve(everytingIsValid)

				//Normal checkout
			} else {
				// Validate skipass first
				const keyCardQueryString = keyNumeberList(
					state.cart.skipass,
					state.user.guests ? state.user.guests : []
				)

				dispatch('GET_KEY_CARD_VALIDATION', keyCardQueryString)
					.then(response => {
						// Loop Skipass
						for (let i = 0; i < cartProductList.length; i++) {
							const product = { ...cartProductList[i] }
							const guestValidation = { ...product.guestValidation }
							const guest = state.user.guests
								? state.user.guests.find(
										each => each.guestlid == product.guestlid
								  )
								: ''

							if (guest) {
								guestValidation.guest = true
								guestValidation.age = validateAge(guest.birthdate, product)

								if (product.type == 'skipass') {
									// Keycard validation
									if (guest.keynumber) {
										if (response) {
											// Keycard validation from response
											const ValidateKeycard = response.filter(
												each => each.keynumber == guest.keynumber
											)
											guestValidation.keycard = ValidateKeycard.length
												? ValidateKeycard[0].valid
												: false
										} else {
											// Keycard validation false if response is bad
											guestValidation.keycard = false
										}
									} else {
										// Keycard validation true if no keycard
										guestValidation.keycard = true
									}

									//Image validation
									if (product.photoMandatory) {
										//guestValidation.image = guest.image != ''
										guestValidation.image = guest.image != '' ? true : false
									} else {
										guestValidation.image = true
									}
								}

								if (product.type == 'skirental') {
									guestValidation.length = guest.length > 0
									guestValidation.weight = guest.weight > 0
									guestValidation.shoesize = guest.shoesize > 0
								}
								if (product.type == 'skischool') {
									guestValidation.phone = guest.phone3
								}
								if (product.type == 'activities') {
									guestValidation.phone = guest.phone3
								}
							} else {
								guestValidation.guest = false
								guestValidation.age = true
								guestValidation.keycard = true
								if (product.guest) {
									guestValidation.guest = true
								}
							}

							for (const key in guestValidation) {
								if (everytingIsValid) {
									everytingIsValid = guestValidation[key]
								}
							}

							commit('VALIDATE_PRODUCTS_IN_CART', {
								type: product.type,
								product: product,
								guestValidation: guestValidation,
								everytingIsValid: everytingIsValid
							})
						}

						resolve(everytingIsValid)
					})
					.catch(error => {
						window.console.error(error)
						resolve(false)
					})
			}
		}).catch(error => {
			window.error(error)
			resolve(false)
		})
	},

	CART_CHECKOUT_CLICK({ commit }, payload) {
		commit('CART_CHECKOUT_CLICK', payload)
	},

	CART_COMPLETE_CANCELLATION({ commit }, payload) {
		commit('CART_COMPLETE_CANCELLATION', payload)
	},

	SET_CHECKOUT_TYPE({ commit, state }, payload) {
		if (
			state.cart.accommodation.length > 0 ||
			state.cart.skirental.length > 0 ||
			state.cart.skischool.length > 0 ||
			state.cart.activities.length > 0 ||
			state.user != null
		) {
			commit('SET_FAST_CHECKOUT', false)
		} else if (state.cart.skipass.length > 0) {
			commit('SET_FAST_CHECKOUT', true)
			state.cart.skipass.map(each => {
				if (each.connected == false || each.photoMandatory == true) {
					commit('SET_FAST_CHECKOUT', false)
				}
			})
		} else {
			commit('SET_FAST_CHECKOUT', true)
		}
	}
}

function validateAge(birthdate, product) {
	const end = product.endDate
		? moment(product.endDate)
		: moment(product.startDate)
	const age = end.diff(birthdate, 'years')
	return age >= product.fromAge && age <= product.toAge
}

function keyNumeberList(skipassList, guestList) {
	const guestsIdWithSkipass = skipassList
		.filter(each => each.addrlid)
		.map(each => each.addrlid)
	const guestsWithSkipass = guestList.filter(each => {
		return guestsIdWithSkipass.includes(each.guestlid) && each.keynumber
	})
	return guestsWithSkipass.map(each => each.keynumber).toString()
}
